import './UserInfo.scss';

const UserInfo = ({ children }) => {
  return <div className="UserInfo">{children}</div>;
};

export default UserInfo;
